import { render } from "./UserChangePassword.html?vue&type=template&id=28eb6679&ts=true"
import script from "./UserChangePassword.ts?vue&type=script&lang=ts"
export * from "./UserChangePassword.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__